import { render, staticRenderFns } from "./box2.vue?vue&type=template&id=0f902394&scoped=true&"
import script from "./box2.vue?vue&type=script&lang=ts&"
export * from "./box2.vue?vue&type=script&lang=ts&"
import style0 from "./box2.vue?vue&type=style&index=0&id=0f902394&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f902394",
  null
  
)

export default component.exports